import { useIsRestoring } from '@tanstack/react-query'
import { App as RevampedApp } from 'v2/App'
import 'v2/compat/country-data'
import { OrgSwitchLoader } from 'v2/shared/components/org-switch-loader'
import { SuspenseLoader } from 'v2/shared/components/suspense-loader'

/**
 * Add loader until react query is hydrated
 */
export const CompatApp = () => {
  const isRestoring = useIsRestoring()

  if (isRestoring) return <SuspenseLoader text="Loading app..." />

  return (
    <>
      <RevampedApp />
      <OrgSwitchLoader />
    </>
  )
}
